import { useEffect } from 'react';
import { createBrowserRouter, Navigate, Outlet, useLocation } from 'react-router-dom';
import { page } from './utils/analytics';
import QuizEntry from './pages/quiz/QuizEntry';
import BusinessQuiz from './pages/quiz/BusinessQuiz';
import ConsumerQuiz from './pages/quiz/ConsumerQuiz';
import ExpressFlow from './pages/express/ExpressFlow';
import RentalQuiz from './pages/rental/RentalQuiz';
import TaxesQuiz from './pages/taxes/TaxesQuiz';
import SequenceQuiz from './pages/quiz/SequenceQuiz';
import AdhdQuiz from './pages/adhd/AdhdQuiz';
import LoadingScreen from './pages/loading/LoadingScreen';
import Results from './pages/results/Results';
import PlanBreakdown from './pages/plan/PlanBreakdown';
import ActivatePage from './pages/activate/ActivatePage';

function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    page();
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }
  }, [location.pathname]);

  return <Outlet />;
}

export const router = createBrowserRouter([
  {
    element: <PageTracker />,
    children: [
      {
        path: '/',
        element: <Navigate to="/quiz" replace />,
      },
      {
        path: '/quiz',
        element: <QuizEntry />,
      },
      {
        path: '/quiz/business',
        element: <BusinessQuiz />,
      },
      {
        path: '/quiz/consumer',
        element: <ConsumerQuiz />,
      },
      {
        path: '/express',
        element: <ExpressFlow />,
      },
      {
        path: '/rental',
        element: <RentalQuiz />,
      },
      {
        path: '/rental/quiz',
        element: <Navigate to="/rental" replace />,
      },
      {
        path: '/taxes',
        element: <TaxesQuiz />,
      },
      {
        path: '/stress',
        element: <SequenceQuiz />,
      },
      {
        path: '/adhd',
        element: <AdhdQuiz />,
      },
      {
        path: '/loading',
        element: <LoadingScreen />,
      },
      {
        path: '/results/:id',
        element: <Results />,
      },
      {
        path: '/plan',
        element: <PlanBreakdown />,
      },
      {
        path: '/activate',
        element: <ActivatePage />,
      },
      {
        path: '*',
        element: <Navigate to="/quiz" replace />,
      },
    ],
  },
]);
